import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import {SellingReportService} from "../../report/service/sellingReport.service";
import {SellingReport} from "../../models/sellingReport";
import {SellingReportList} from "../../models/sellingReportList";

@Injectable()
export class ProductTotalSummaryByYearResolve implements Resolve<SellingReportList> {
    constructor(private sellingReportService: SellingReportService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<SellingReportList> {
        return this.sellingReportService.getProductTotalByYearSummary(route.params.id);
    }
}
